import { render, staticRenderFns } from "./Sujet.vue?vue&type=template&id=1c005bbc&"
import script from "./Sujet.vue?vue&type=script&lang=js&"
export * from "./Sujet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports